import { hubDailyReportTableOptionTypeMapper } from '@/constants/hubAdjustment/daily';
import HubAdjustmentDailyReportItem from '@/entity/HubAdjustmentDailyReportItem';
import { numberToFormatted, validateCountWithHypen, } from '@/utils';
export default class HubAdjustmentDailyReport {
    _report;
    _items;
    constructor(report) {
        this._report = report;
        this._items = report.map((item) => new HubAdjustmentDailyReportItem(item));
    }
    get items() {
        return this._items;
    }
    getCsvHeaderAndData(type) {
        const headers = hubDailyReportTableOptionTypeMapper[type];
        const headerLocale = headers.map((header) => header.title);
        let data = this.items.map((item) => {
            // 구분: response 그대로 아닌 B2B, 로드샵
            const row = headers.map((key) => {
                if (key.origin === 'storeType') {
                    return item.formattedStoreType?.text;
                }
                // @ts-ignore
                return `"${item._item[key.origin]}"`;
            });
            return row;
        });
        const totalRow = headers.map((header, idx) => {
            if (idx === 0) {
                return '총';
            }
            if (!header.total) {
                return '';
            }
            return this.getTotalValueByKey(header.origin, false);
        });
        data = data.concat([
            totalRow,
        ]);
        return {
            header: headerLocale,
            data,
        };
    }
    getTotalValueByKey(key, suffix = true) {
        const result = this._report
            // @ts-ignore string key를 받지 않음 구조 수정 어려움 임시 패치 HELP!(하준)
            .map((item) => item[key])
            .reduce((prev, current) => prev + current, 0);
        if (!suffix) {
            return result;
        }
        const keyWithCountSuffix = [
            'storeManagementDepositWithdrawalCount',
            'orderCompletedCount',
        ];
        if (keyWithCountSuffix.includes(key)) {
            return validateCountWithHypen(numberToFormatted(result));
        }
        return numberToFormatted(result, {
            style: 'currency',
        });
    }
}
